import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetActivarTicket: null,
    statusSetActivarTicket: null,
    activarTicket: [],
    activarTicketConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setActivarTicket (state, data) {
      state.activarTicket = data
    },
    setResponseUpdateActivarTicketConfig (state, data) {
      state.statusSetActivarTicket = data
    },
    setResponseGetActivarTicket (state, data) {
      state.statusGetActivarTicket = data
    },
    setResponseActivarTicketMsg (state, data) {
      state.activarTicketConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getActivarTicketConfig ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        console.log(JSON.parse(atob(localStorage.getItem('uid'))).rol.trim);
        console.log('Desarrollador');

        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getTicketConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setActivarTicket', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetActivarTicket', true)
            commit('setResponseActivarTicketMsg', 'Hubo un error obteniendo la configuración  ticket como factura contigencia. Intentelo nuevamente.')
          } else {
            commit('setResponseGetActivarTicket', false)
            commit('setResponseActivarTicketMsg', 'Configuración de ticket como factura de contingencia consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetActivarTicket', true)
          commit('setResponseActivarTicketMsg', 'No pudo obtener  configuración  ticket como factura contigencia. Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateActivarTicketConfig ({ commit }, data) {
      const endpoint = '/api/updateTicketConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateActivarTicketConfig', true)
              commit('setResponseActivarTicketMsg', 'Hubo un error guardando la configuración de ticket como factura contigencia. Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateActivarTicketConfig', false)
              commit('setResponseActivarTicketMsg', 'Configuración de ticket como factura de contingencia guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateActivarTicketConfig', true)
          commit('setResponseActivarTicketMsg', 'No pudo obtener información de la configuración de ticket como factura contigencia.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateActivarTicketConfig', data)
    },
    statusGetActivarTicket ({ commit }, data) {
      commit('setResponseGetActivarTicket', data)
    },
  },
}
